import { Component, Input, OnInit } from '@angular/core';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmergencyContact } from '@app/core/types/membership/membership.types';

const DEFAULT_PHONE_NUMBER = '+316';

@Component({
    selector: 'c-emergency-contact-modal',
    templateUrl: './emergency-contact-modal.component.html',
    styleUrls: ['./emergency-contact-modal.component.scss'],
    standalone: false
})
export class EmergencyContactModalComponent implements OnInit {
  readonly closeIcon = faXmark;
  @Input() close!: () => void;
  @Input() onSave!: (emergencyContact: EmergencyContact) => void;
  @Input() emergencyContact!: EmergencyContact;

  form: FormGroup = this.formBuilder.group({
    firstName: this.formBuilder.control(null, [Validators.required]),
    lastName: this.formBuilder.control(null, [Validators.required]),
    phoneNumber: this.formBuilder.control(DEFAULT_PHONE_NUMBER, [Validators.required]),
  });

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    if (this.emergencyContact) {
      this.form.patchValue({ ...this.emergencyContact });
    }
  }

  canSave(): boolean {
    return this.form.valid;
  }

  save() {
    if (!this.canSave()) {
      return;
    }

    this.onSave(this.form.value);
    this.close();
  }
}
